var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button login-button",class:{
        'disabled': _vm.busy || _vm.disabled,
    },attrs:{"tabindex":"0"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('login')}}},[(_vm.icon !== null)?_c('div',{staticClass:"vendor-icon",domProps:{"innerHTML":_vm._s(_vm.icon)}}):_vm._e(),_c('span',{staticClass:"btn-text",class:{
            'no-icon': _vm.icon === null,
        }},[(!_vm.busy)?[_vm._v(_vm._s(_vm.text))]:[_c('Spinner')]],2)])}
var staticRenderFns = []

export { render, staticRenderFns }